<template>
  <div class="content">
    <div class="title-img">
      <img src="../assets/logo.png" alt="CNHO Logo" class="logo" />
      <div class="diver"></div>
      <h1 class="title">FAUCET</h1>
    </div>
    <div class="search-box">
      <el-input
        placeholder="Input Your Account Address to Receive Free CNHO Token"
        v-model="account"
        @keyup.enter.native="account"
        class="input-box"
      />
      <div
        class="claim-button"
        :class="{ 'claim-button-active': account }"
        @click="claimToken"
      >
        {{ buttonText }}
      </div>
    </div>
    <el-dialog
      custom-class="search-dialog"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div>
        <div>
          <img src="../assets/icon_congrats_96@2x.png" class="dialog-logo" />
        </div>
        <div class="dialog-title">
          <div>Congratulations!</div>
          <div>Your Free CNHO has been Sent!</div>
        </div>
        <div class="dialog-message">
          <div class="title">Start your CNHO Stables journey!</div>
          <div class="account-number">{{ accountNumber }}</div>
        </div>
        <div class="dialog-button" @click="CheckBalance">
          Claimed! Check your balance
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import router from "@/router";
export default {
  data() {
    return {
      account: "",
      dialogVisible: false,
      buttonText: "Claim",
      accountNumber: "",
    };
  },
  methods: {
    faucet() {
      this.buttonText = "Claim...";
      let data = {
        address: this.account,
        coins: ["10ucnho"],
      };
      this.$api
        .faucet(data)
        .then((response) => {
          this.buttonText = "Claim";
          console.log(response)
          if (!response.data.error) {
            this.accountNumber=this.account
            this.dialogVisible = true;
          } else {
            this.$message.error(response.data.error||"Invalid address or token");
            this.buttonText = "Claim";
          }
        })
        .catch((error) => {
          this.$message.error(error||"Invalid address or token");
          this.buttonText = "Claim";
        });
    },
    claimToken() {
      this.faucet();
    },
    CheckBalance() {
      let id = this.account;
      const url = `https://explorer.cnho.io/account/${id}`;
      window.location.href = url;
      // if (!id.startsWith('cnho')) {
      // this.$router.push({ name: "Transaction", params: { id } });
      // }else{  
      // this.$router.push({ name: "Account", params: { id } });
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-dialog {
  .dialog-logo {
    width: 96px;
  }
  .dialog-title {
    margin-top: 68px;
    font-size: 28px;
    font-weight: bold;
  }
  .dialog-message {
    margin-top: 24px;
    text-align: left;
    color: #000;
    .title {
      font-size: 15px;
      margin-bottom: 4px;
    }
    .account-number {
      font-size: 17px;
      padding: 10px 12px;
      background: rgba(56, 180, 139, 0.06);
      border-radius: 6px;
      opacity: 0.6;
    }
  }
  .dialog-button {
    background-color: #028760;
    font-size: 17px;
    padding: 10px;
    border-radius: 6px;
    margin-top: 100px;
    color: #fff;
    cursor: pointer;
  }
}

.dialog-title {
  text-align: left;
  color: #000;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f8f8f8;
  .title-img {
    display: flex;
    align-items: center;
    margin-bottom: 64px;
    margin-top:-8%;
    .diver {
      height: 24px;
      border: 2px solid #000;
      margin: 0 24px;
    }
  }
  .search-box {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 4px;
    width: 720px;
  }
}

.logo {
  width: 210px;
}

.title {
  font-size: 40px;
  font-weight: bold;
  color: #000;
}

.input-box {
  width: 600px;
  margin-right: 20px;
}

.claim-button {
  background-color: #cbe6de;
  color: #fff;
  border-radius: 5px;
  width: 132px;
  height: 44px;
  text-align: center;
  font-size: 17px;
  line-height: 44px;
  cursor: pointer;
}
.claim-button-active {
  background-color: #018761 !important;
}
</style>
<style>
.input-box .el-input__inner {
  border: none;
  box-shadow: none;
}

.input-box .el-input__inner:focus {
  border: none;
  box-shadow: none;
}
.search-dialog .el-dialog__body {
  padding: 100px 80px 110px;
}
.search-dialog.el-dialog {
  border-radius: 28px;
  width: 600px !important;
}
</style>
